import { Loader } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '~/lib/utils'

/**
 * Indicateur de chargement annoncé (RGAA 7.5) : une région de statut qui dit
 * « Chargement » au lecteur d'écran. L'icône seule tournait en silence.
 */
function Spinner({ className, label }: { className?: string, label?: string }) {
  const { t } = useTranslation()
  return (
    <span role="status" className="inline-flex">
      <Loader className={cn('animate-spin', className)} aria-hidden />
      <span className="sr-only">{label ?? t('common.loading')}</span>
    </span>
  )
}

export default Spinner
